<header>
  <div class="navbar-wrapper">
    <div class="navbar-logo-pnl">
      <img class="bidit-logo" alt="BiditWeb" src="assets/img/Bidit_Logo_{{locale}}.png" />
    </div>
    <div class="navbar-content float-right">
        <div class="d-flex flex-row w-100">
            <h3 class="navbar-label flex-fill" i18n>CONSTRUCTION MANAGEMENT RESOURCE TOOL</h3>
            <div class="pt-3">
                <select name="locale" class="form-control select-bidit" [(ngModel)]="locale" (ngModelChange)="updateLocale()">
                    <option value="en">English</option>
                    <option value="es">Español</option>
                </select>
            </div>
            <a class="nav-link warning pt-3 mt-1" style="width:150px; text-align:center;" href="#" (click)="logout($event)" i18n>Log Out</a>
        </div>
      <div class="clearfix"></div>
      <nav class="navbar navbar-expand-sm navbar-bidit navbar-light navbar-toggleable-sm">
        <div class="container">
          <button class="navbar-toggler"
                  type="button"
                  data-toggle="collapse"
                  data-target=".navbar-collapse"
                  aria-label="Toggle navigation"
                  [attr.aria-expanded]="isExpanded"
                  (click)="toggle()">
            <span class="navbar-toggler-icon"></span>
          </button>
          <div class="navbar-collapse collapse d-sm-inline-flex flex-sm-row-reverse"
               [ngClass]="{ show: isExpanded }">
            <ul class="navbar-nav flex-grow">
              <li [hidden]="isFieldTech" class="nav-item bidit-nav-item" [routerLinkActive]="['bidit-nav-active']"
                  [routerLinkActiveOptions]="{ exact: true }">
                <a class="nav-link text-light" [routerLink]="['/']" (click)="toggle()" i18n>Home</a>
              </li>
              <li [hidden]="hideQuoteTabs" class="nav-item bidit-nav-item" [routerLinkActive]="['bidit-nav-active']">
                <a class="nav-link text-light" [routerLink]="['/customer']" (click)="toggle()" i18n>Customers</a>
              </li>
              <li [hidden]="hideQuoteTabs" class="nav-item bidit-nav-item" [routerLinkActive]="['bidit-nav-active']">
                <a class="nav-link text-light" [routerLink]="['/lead']" (click)="toggle()" i18n>Leads</a>
              </li>
              <li [hidden]="hideQuoteTabs" class="nav-item bidit-nav-item" [routerLinkActive]="['bidit-nav-active']">
                <a class="nav-link text-light" [routerLink]="['/quote']" (click)="toggle()" i18n>Quotes</a>
              </li>
              <li [hidden]="hideJobTools" class="nav-item bidit-nav-item" [routerLinkActive]="['bidit-nav-active']">
                <a class="nav-link text-light" [routerLink]="['/job']" (click)="toggle()" i18n>Jobs</a>
              </li>
              <li [hidden]="hideJobTools" class="nav-item bidit-nav-item" [routerLinkActive]="['bidit-nav-active']">
                  <a class="nav-link text-light" [routerLink]="['/workorder']" (click)="toggle()" i18n>Work Orders</a>
              </li>
              <li *ngIf="isIDIAdmin || isDealerAdmin" class="nav-item bidit-nav-item" [routerLinkActive]="['bidit-nav-active']">
                <a class="nav-link text-light" [routerLink]="['/admin']" (click)="toggle()" i18n>Admin</a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
      <div class="float-right">
        <div class="text-light navbar-user-icon">
          <img src="assets/img/icons/user_icon.png" alt="User" />
          <span i18n>Hi</span> {{username}}
        </div>
      </div>
      <div class="clearfix"></div>
    </div>
  </div>
  <div class="clearfix"></div>
</header>
